import React from 'react';
import logo from '../images/crms/fub.png';

function FUB(props) {
    const className = props.className;
    return (
        <img
            src={logo}
            alt=""
            className={className}
            style={{ width: '130%', height: '130%', objectFit: 'contain' }}
        />
    );
}

export default FUB;
